<template>
    <div class="container">
        <div class="agent-register-complete">
            <h1 class="page_h1">訂單</h1>
            <div class="form f-row">
                <div class="register_step">
                    <h4 class="register_title">發生錯誤</h4>
                    <p class="register_txt">請聯絡我們，我們會盡快處理問題</p>
                    <a href="mailto:heavenyi4687@gmail.com">heavenyi4687@gmail.com</a>
                </div>
                <div class="form_grp f-col@lg:auto align:r mg-t-12">
                    <button class="btn w:full clr:primary" @click="onClick">前往付款記錄</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "paymentReturnError",
        methods:{
            onClick() {
                window.location = '/orders'
            }
        }
    }
</script>

<style scoped>
    .router_link {
        font-size: 0.875rem;
    }

    .reset-mg\:b {
        margin-bottom: 0.75rem;
    }
</style>
